<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="minMaxScaleModal">
    <div style="background-color: #548235; height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)"
         style="background-color: #a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">{{ title }}</h5>
    </div>

    <div class="modal-body" style="margin-top: -1px; padding: 15px;">
        <!-- Max above Min to mirror the Y-axis (top = max, bottom = min). -->
        <div class="form-group" style="margin-bottom: 10px;">
            <label style="display: block; font-weight: 500; margin-bottom: 2px;">Max</label>
            <input type="number" class="form-control" name="scaleMax" [(ngModel)]="max" placeholder="auto" />
        </div>

        <div class="form-group" style="margin-bottom: 10px;">
            <label style="display: block; font-weight: 500; margin-bottom: 2px;">Min</label>
            <input type="number" class="form-control" name="scaleMin" [(ngModel)]="min" placeholder="auto" />
        </div>

        <small class="text-muted">Leave a field blank to autoscale that end. Clear both to remove manual scaling.</small>

        <div style="margin-top: 15px; display: flex; gap: 8px; align-items: center;">
            <button type="button" class="btn btn-success" (click)="apply()">Apply</button>
            <button type="button" class="btn btn-outline-secondary" (click)="clear()">Clear</button>
            <button type="button" class="btn btn-basic" style="margin-left: auto;" (click)="cancel()">Cancel</button>
        </div>
    </div>
</div>
